/**
 * UI View Keys
 *
 * Mirrors the backend {@code com.wadakaroo.model.UiViewKey} enum.
 * Each value corresponds to a nav item in Layout.jsx and the backend
 * embeds an allow-list of these keys in the JWT `uiViews` claim.
 *
 * When adding a new nav item:
 *  1. Add a new key here (SCREAMING_SNAKE_CASE, same as backend enum).
 *  2. Add the matching value to {@code UiViewKey.java}.
 *  3. Tag the nav item in Layout.jsx with the key.
 */
export const UiViewKey = Object.freeze({
    // Operations
    BOOKINGS: 'BOOKINGS',
    DASHBOARD: 'DASHBOARD',
    CUSTOMER_COMMUNICATIONS: 'CUSTOMER_COMMUNICATIONS',
    INVOICES: 'INVOICES',
    QUOTES: 'QUOTES',
    JOBS: 'JOBS',
    VEHICLES: 'VEHICLES',
    SERVICE_RECORDS: 'SERVICE_RECORDS',
    FLEET_CUSTOMERS: 'FLEET_CUSTOMERS',
    CUSTOMER_REVIEWS: 'CUSTOMER_REVIEWS',

    // Resources & Inventory
    RESOURCE_PLANNING: 'RESOURCE_PLANNING',
    STOCK_MANAGEMENT: 'STOCK_MANAGEMENT',
    PROCUREMENT: 'PROCUREMENT',

    // Configuration
    WORK_ITEMS: 'WORK_ITEMS',
    SERVICE_PROFILES: 'SERVICE_PROFILES',
    TEAM_MEMBERS: 'TEAM_MEMBERS',
    STAFF_PERMISSION_PROFILES: 'STAFF_PERMISSION_PROFILES',
    UI_VIEW_PROFILES: 'UI_VIEW_PROFILES',
    ACCOUNTING_SOFTWARE: 'ACCOUNTING_SOFTWARE',
    ORGANISATION: 'ORGANISATION',

    // Profile menu
    MY_PROFILE: 'MY_PROFILE',
    SECURITY: 'SECURITY',
    SETTINGS: 'SETTINGS',
    HELP_SUPPORT: 'HELP_SUPPORT',

    // Fleet portal (customer-facing) — used by fleet CLIENT users' nav.
    // Distinct from FLEET_CUSTOMERS above, which is the workshop-side
    // "Fleet Customers" management nav item.
    FLEET_VEHICLES: 'FLEET_VEHICLES',
    FLEET_BOOKINGS: 'FLEET_BOOKINGS',
    FLEET_INVOICES: 'FLEET_INVOICES',
    FLEET_SERVICE_RECORDS: 'FLEET_SERVICE_RECORDS',
    FLEET_SETTINGS: 'FLEET_SETTINGS',
});